import React, {FC} from "react";
import {Flex} from "../../../../../newShared/components/Layouts";
import {useMainTranslation} from "../../../../../newShared/hooks/useMainTranslationHooks/useMainTranslation";
import {useMedia} from "../../../../../newShared/hooks/useMedia";

//icons
//other
import colors from "../../../../../newShared/theme/colors";
import {Box, Button, IconButton, MenuItem, Skeleton, TextField, Typography} from "@mui/material";
import {LoadingButton} from "@mui/lab";
import {CreateSettingRowDialog} from "../../components/Dialogs/CreateSettingRowDialog";
import {AddMenuItem} from "../../../../../newShared/components/Basic/AddMenuItem";
import {useCertificateAssetNew} from "../../hooks/useCertificateAssetNew";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import {PageTitleAndActions} from "../../../../../newShared/components/pageTitleAndActions";


export const CertificateAssetNew: FC = () => {
    const {isMobile} = useMedia();
    const {t, revDir} = useMainTranslation('', {keyPrefix: 'pathPhysicalAssets'});

    const {
        settings,
        form,
        handleChange,
        file,
        fileName,
        ref,
        filePicker,
        fileHandler,
        handleDeleteFile,

        handleSave,
        handleGoBack,

        handleSetRenewal,
        handleChangeCustomField,

        isLoadingSettings,
        isLoadingCreateAsset,

        openCreateSettingRowDialog
    } = useCertificateAssetNew();


    return (
        <Flex w={'100%'} h={'100%'} direction={'column'}>
            <PageTitleAndActions
                title={t('New certificate')}
                handleGoBack={handleGoBack}
                actions={[]}
            />

            {/*<Breadcrumbs/>*/}
            {/*<Flex ai={'center'}>*/}
            {/*    {!isMobile &&*/}
            {/*        <IconButton sx={{color: colors.text.blue, margin: !revDir ? `${!isLessThen1050 ? 11 : 4}px 12px ${!isLessThen1050 ? 4 : 2}px 0` : `${!isLessThen1050 ? 11 : 4}px 0 ${!isLessThen1050 ? 4 : 2}px 12px`, padding: '0'}}*/}
            {/*                    onClick={handleGoBack} size={isLessThen1050 ? 'small' : undefined}>*/}
            {/*            {!revDir ? <ArrowBack/> : <ArrowForward/>}*/}
            {/*        </IconButton>}*/}
            {/*    <Typography variant={isMobile ?  'h3' : "h1"}  sx={{color: colors.backgrounds.dark}}>{'New Certificate'}</Typography>*/}
            {/*</Flex>*/}

            <Flex ai={'center'} m={'32px 0 0 0'}>

                <LoadingButton size={"large"} component={"label"}
                               variant={'contained'}
                               disabled={isLoadingCreateAsset || !form.name.trim().length || !file}
                               onClick={handleSave} loadingPosition={isLoadingCreateAsset ? 'start' : undefined} loading={isLoadingCreateAsset}
                               startIcon={isLoadingCreateAsset ? <div style={{width: '10px', height: '10px', }}/> : undefined}
                               sx={{margin: !revDir ? '0 16px 0 0' : '0 0 0 16px'}}
                >
                    {t('Save')}
                </LoadingButton>

                <Button disabled={isLoadingCreateAsset} variant={'outlined'} size={isMobile ? 'small' : 'medium'} onClick={handleGoBack} >
                    {t('Cancel')}
                </Button>
            </Flex>

            <Flex direction={"column"}  w={'100%'} overflowy={'auto'} m={'10px 0 0 0'} >
                {isLoadingSettings ?
                    <>
                        <Skeleton width={'300px'} height={'40px'} />
                        <Skeleton width={'300px'} height={'40px'} />
                        <Skeleton width={'300px'} height={'40px'} />
                        <Skeleton width={'300px'} height={'40px'} />
                        <Skeleton width={'300px'} height={'40px'} />
                        <Skeleton width={'300px'} height={'40px'} />
                        <Skeleton width={'300px'} height={'40px'} />

                    </>
                    :
                    <>


                        <Box display={'flex'}>
                            { !!fileName.length ?
                                <Flex ai={'center'} w={'100%'}>
                                    <Typography sx={{margin: !revDir ? '0 5px 0 0' : '0 0 0 5px'}} color={colors.text.grey_dark}>{fileName}</Typography>
                                    <IconButton onClick={handleDeleteFile}>
                                        <DeleteOutlineSharpIcon fontSize={'small'}/>
                                    </IconButton>
                                </Flex>
                                :
                                <Flex ai={'center'} m={'16px 0 0 0'}>
                                    <Button sx={{width: 'max-content'}} startIcon={<FileUploadIcon />} onClick={filePicker} variant={'text'}>
                                        {t('SELECT CERT FILE')}
                                    </Button> 

                                    {/*<Typography fontSize={'13px'} fontWeight={600} color={colors.primary.blue} sx={{margin: !revDir ? '0 5px 0 0' : '0 0 0 5px', cursor: 'pointer', whiteSpace: 'nowrap'}} onClick={filePicker}>{t('SELECT FILE')}</Typography>*/}
                                    <input
                                        accept={'.csv'}
                                        style={{ visibility: "hidden", opacity: 0}}
                                        ref={ref}
                                        type="file"
                                        onChange={(e) => fileHandler(e.target.files)}
                                    />

                                </Flex>
                            }
                        </Box>

                        <TextField label={t('Name')} size={"small"}
                                   required
                                   sx={{mt: '16px', width: '320px', '& label': {top: '0 !important'}}}
                                   value={form.name} onChange={handleChange} name={'name'} />

                        <TextField select fullWidth label={t('Renewal')} value={form.renewal} size={'small'}
                                   sx={{mt: '16px', width: '320px', '& label': {top: '0 !important'}}}
                                   onChange={(e) => handleSetRenewal(e.target.value)}
                        >
                            <AddMenuItem text={t('Add new')} onClick={() => openCreateSettingRowDialog({isOpen: true, field: 'renewal', assetType: 'certificate'})} />
                            { settings && Object.keys(settings.renewal) && Object.keys(settings.renewal).map((type) => <MenuItem key={type} value={type}>{type}</MenuItem>)}
                        </TextField>

                        <TextField label={t('Owner')} value={form.owner} size={'small'}
                                   sx={{marginTop: '16px', width: '320px', '& label': {top: '0 !important'}}}
                                   onChange={handleChange} name={'owner'} />


                        {(settings && settings.customFields && !!Object.keys(settings.customFields).length) &&
                            Object.keys(settings.customFields).map((e) =>
                                (<TextField key={e} size={'small'} label={e} value={form.customFields[e] || ''} name={e}
                                           onChange={handleChangeCustomField} sx={{marginTop: '16px', width: '320px', '& label': {top: '0px !important'}}}
                                />)
                            )}
                    </>
                }

            </Flex>

            <CreateSettingRowDialog onSuccess={handleSetRenewal}/>
        </Flex>
    )
}